import type { ListBuilderList } from '../../../types';
import { createDefaultCompetitorColumns } from '../columns';
import { ACTIVE_COMPETITORS_RULE } from '../shared';

/** Competitors that are the primary supplier of at least one of our customers. */
export const primaryAtOurCustomersCompetitorsList: ListBuilderList = {
	id: 'default-competitors-primary',
	cacheTTL: 600000,
	name: 'Primary At Our Customers',
	type: 'default',
	active: true,
	sortOrder: 2,
	columns: createDefaultCompetitorColumns(),
	description:
		'Competitors that are the primary supplier for at least one customer',
	defaultSortId: 'column-competitor-customers-desc',
	filterRules: {
		competitorStatus: ACTIVE_COMPETITORS_RULE,
		competitorRelationship: {
			defaultValue: [{ id: 'primary', label: 'Primary' }],
			locked: true,
			hidden: true,
		},
	},
};
